import React from 'react';
import ImmutablePureComponent from 'react-immutable-pure-component';
import { unescape as unescapeHtml } from 'lodash';
import RelativeTimestamp from '../../../../brighteon/components/relative_timestamp';

export class FeedItem extends ImmutablePureComponent {

  processHeadline = (text) => {
    return unescapeHtml(text)
      .replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(dec));
  }

  render() {
    const {
      headline,
      date,
      link,
      newsSource,
    } = this.props;

    if (date) {
      return (
        <div className='uncensored-news-feed__item'>
          <a href={link} target='_blank'>
            <div className='uncensored-news-feed__item__headline'>
              {this.processHeadline(headline)}
            </div>
            <div className='uncensored-news-feed__item__description'>
              <span>{newsSource}</span> • <RelativeTimestamp timestamp={(new Date(date)).toISOString()} />
            </div>
          </a>
        </div>
      );
    }
    return (<></>);

  }

}
